export default
    {
        library: [
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-chevron-left text-primary",
                position: "toolbar",
                action: "back",
                label: "Back",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-floppy-o text-primary",
                position: "toolbar",
                action: "save",
                label: "Save It",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-floppy-o text-primary",
                position: "toolbar",
                action: "post",
                label: "Post It",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-play text-primary",
                position: "toolbar",
                action: "go",
                label: "Go",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-bolt text-warning",
                position: "toolbar",
                action: "autoquery",
                label: "Auto",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-filter text-primary",
                position: "toolbar",
                action: "filter",
                label: "Filter",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-calendar-check-o text-primary",
                position: "toolbar",
                action: "updated",
                label: "Updated",
                single: true,
                multiple: false,
                disabled: true,
                permission: "save",
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-hourglass-start text-warning",
                position: "toolbar",
                action: "pending",
                label: "Pending",
                single: true,
                multiple: false,
                disabled: true,
                permission: "save",
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-plus text-primary",
                position: "toolbar",
                action: "add",
                label: "Add",
                single: true,
                multiple: false,
                disabled: true,
                permission: "save",
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-text-width text-black",
                position: "toolbar",
                action: "rename",
                label: "Rename",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-times text-danger",
                position: "toolbar,actions",
                action: "remove",
                label: "Remove",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-long-arrow-up text-info",
                position: "toolbar,actions",
                action: "up",
                label: "Up",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-long-arrow-down text-info",
                position: "toolbar,actions",
                action: "down",
                label: "Down",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa fa-angle-double-up text-info",
                position: "toolbar,actions",
                action: "top",
                label: "Top",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa fa-angle-double-down text-info",
                position: "toolbar,actions",
                action: "bottom",
                label: "Bottom",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-clone text-primary",
                position: "toolbar",
                action: "copy",
                label: "Copy",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-clipboard text-primary",
                position: "toolbar",
                action: "clipboard",
                label: "Clipboard",
                single: true,
                multiple: false,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-scissors text-primary",
                position: "toolbar",
                action: "cut",
                label: "Cut",
                single: true,
                multiple: false,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-clipboard text-primary",
                position: "toolbar",
                action: "paste",
                label: "Paste",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-clipboard text-warning",
                position: "toolbar",
                action: "pastespecial",
                label: "Paste Special",
                single: true,
                multiple: false,
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-share-alt text-primary",
                position: "toolbar",
                action: "clone",
                label: "Clone",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-power-off text-danger",
                position: "toolbar",
                action: "reset",
                label: "Reset",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-recycle text-danger",
                position: "toolbar",
                action: "recycle",
                label: "Recycle",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-upload text-primary",
                position: "toolbar",
                action: "import",
                label: "Import",
                disabled: true,
                permission: "save",
                component: {
                    name: "FilesUpload",
                    config: [],
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-cloud-download text-primary",
                position: "toolbar",
                action: "update",
                label: "Update",
                disabled: true,
                permission: "save",
                component: {
                    name: "FilesUpload",
                    config: [],
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-tags text-purple",
                position: "toolbar",
                action: "inventory",
                label: "Inventory",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-paper-plane text-info",
                position: "toolbar,actions",
                action: "submit",
                label: "Draft",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-pencil text-primary",
                position: "toolbar,actions",
                action: "edit",
                label: "Edit",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-trash text-danger",
                position: "toolbar,actions",
                single: true,
                multiple: true,
                disabled: true,
                permission: "delete",
                action: "deleteconfirm",
                label: "Delete",
                overlay: {
                    message: "Are you sure you want to delete row %index% ?",
                    buttons: [
                        {
                            label: "Yes",
                            variant: "danger",
                            action: "delete",
                        },
                        {
                            label: "No",
                            class: "ml-2",
                        },
                    ],
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-refresh text-primary",
                position: "toolbar",
                action: "refresh",
                label: "Refresh",
                disabled: true,
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-download text-info",
                position: "toolbar",
                action: "download",
                label: "Download",
                rule: "attachment",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-download text-info",
                position: "toolbar",
                action: "csvexport",
                label: ".CSV",
                rule: "attachment",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-download text-info",
                position: "toolbar,actions",
                action: "csv",
                label: ".CSV",
                rule: "attachment",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-repeat text-primary",
                action: "archive",
                position: "toolbar",
                label: "Archive",
                disabled: true,
                permission: "save",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-undo text-primary",
                action: "unarchive",
                position: "toolbar",
                label: "Unarchive",
                disabled: true,
                permission: "save",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-undo text-danger",
                action: "credit",
                position: "toolbar,actions",
                label: "Credit",
                disabled: true,
                permission: "save",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-file-excel-o text-primary",
                position: "toolbar",
                action: "export",
                title: "Export to Excel",
                label: "Export",
                disabled: true,
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-wrench text-purple",
                action: "fix",
                position: "toolbar",
                label: "Fix It",
                disabled: true,
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-expand text-primary",
                action: "expand",
                position: "toolbar,actions",
                label: "Expand",
                disabled: true,
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-search-plus text-info",
                action: "view",
                position: "toolbar,actions",
                label: "View",
                disabled: true,
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-file-code-o text-primary",
                position: "toolbar",
                action: "xml",
                label: "XML",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-compress text-primary",
                position: "toolbar",
                action: "anonymisersame",
                label: "Same",
                disabled: true,
                permission: "save",
                component: {
                    name: "AnonymiserSame",
                    
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-commenting-o",
                position: "toolbar",
                action: "notes",
                label: "Notes",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-hourglass-end text-warning",
                position: "toolbar,actions",
                action: "zhold",
                label: "Zhold",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-wpforms text-info",
                position: "toolbar,actions",
                action: "invoiced",
                label: "Invoiced",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-undo text-danger",
                action: "credited",
                position: "toolbar",
                label: "Credited",
                disabled: true,
                permission: "save",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-map-marker text-purple",
                action: "missing",
                position: "toolbar",
                label: "Missing",
                disabled: true,
                permission: "save",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-exclamation-circle text-danger",
                action: "error",
                position: "toolbar",
                label: "Error",
                disabled: true,
                permission: "save",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-wpforms text-info",
                position: "toolbar,actions",
                action: "invoice",
                label: "Invoice",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-file-pdf-o text-primary",
                position: "toolbar,actions",
                action: "pdf",
                label: "PDF",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-gbp text-primary",
                position: "toolbar",
                action: "payment",
                label: "Payments",
                disabled: true,
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-cloud-upload text-primary",
                position: "toolbar",
                action: "upload",
                label: "Upload",
                disabled: true,
                permission: "save",
                component: {
                    name: "",
                    config: [],
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-square-o text-info",
                position: "actions",
                action: "seat_ss",
                label: "Toggle 'SS' (clear to sell)",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-square-o text-warning",
                position: "actions",
                action: "seat_hk",
                label: "Toggle 'HK' (hold confirmed)",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-square text-dark",
                position: "toolbar",
                action: "void",
                label: "Void",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-repeat text-warning",
                position: "toolbar",
                action: "void",
                label: "Change",
                disabled: true,
                component: {
                    name: "",
                },
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-magic text-info",
                position: "toolbar",
                action: "wizard",
                label: "Wizard",
                component: {
                  name: "",
                },
              },
              {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-ban danger",
                position: "toolbar",
                action: "ban",
                label: "Clear",
            },
              {
                type: "button",
                size: "sm",
                variant: "outline-white",
                squared: "squared",
                icon: "fa fa-text-height text-primary",
                position: "toolbar",
                action: "textsize",
                label: "Text size",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_0",
                label: "Sheet 0",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_1",
                label: "Sheet 1",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_2",
                label: "Sheet 2",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_3",
                label: "Sheet 3",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_4",
                label: "Sheet 4",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_5",
                label: "Sheet 5",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_6",
                label: "Sheet 6",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_7",
                label: "Sheet 7",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_8",
                label: "Sheet 8",
            },
            {
                type: "button",
                size: "sm",
                variant: "outline-primary",
                squared: "squared",
                position: "sheets",
                action: "sheet_9",
                label: "Sheet 9",
            },
        ]
    }